import React from 'react';
import { useI18n } from 'react-simple-i18n';
import { getLocaledString } from '../appstate';

export default function TermsOfUse() {
	const { t } = useI18n();

	return (
		<div className={'w-full flex flex-col'}>
			<div
				className={
					'text-4xl w-full text-center text-primary-500 relative z-10 mb-4 md:mb-0 px-6 select-none font-bold'
				}
				style={{ marginTop: '-3.5vh' }}
				id={'ddt'}
			>
				– {getLocaledString('Pogoji uporabe', 'Terms of Use')} –
			</div>
			<div className={'w-full h-8'} />

			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 mb-8 md:mb-0'
				}
			>
				<div
					className={'text-lg leading-8 leading-8 mb-12'}
					dangerouslySetInnerHTML={{
						__html: t('terms.body1').split('\n').join('<br />'),
					}}
				/>
				<div className={'text-left'}>
					<span
						className={'text-4xl mb-5 text-primary-500 font-bold'}
						dangerouslySetInnerHTML={{
							__html: t('terms.title1'),
						}}
					/>
				</div>
				<div
					className={'text-lg leading-8 leading-8 mb-12 mt-7'}
					dangerouslySetInnerHTML={{
						__html: t('terms.body2').split('\n').join('<br />'),
					}}
				/>

				<div className={'text-left'}>
					<span
						className={'text-4xl mb-5 text-primary-500 font-bold'}
						dangerouslySetInnerHTML={{
							__html: t('terms.title2'),
						}}
					/>
				</div>
				<div
					className={'text-lg leading-8 leading-8 mb-12 mt-7'}
					dangerouslySetInnerHTML={{
						__html: t('terms.body3').split('\n').join('<br />'),
					}}
				/>

				<div className={'text-left'}>
					<span
						className={'text-4xl mb-5 text-primary-500 font-bold'}
						dangerouslySetInnerHTML={{
							__html: t('terms.title3'),
						}}
					/>
				</div>
				<div
					className={'text-lg leading-8 leading-8 mb-12 mt-7'}
					dangerouslySetInnerHTML={{
						__html: t('terms.body4').split('\n').join('<br />'),
					}}
				/>

				<div className={'text-left'}>
					<span
						className={'text-4xl mb-5 text-primary-500 font-bold'}
						dangerouslySetInnerHTML={{
							__html: t('terms.title4'),
						}}
					/>
				</div>
				<div
					className={'text-lg leading-8 leading-8 mb-12 mt-7'}
					dangerouslySetInnerHTML={{
						__html: t('terms.body5').split('\n').join('<br />'),
					}}
				/>
			</div>
		</div>
	);
}
